import { useEffect, useState } from 'react';
import logo from '../../asset/navbar-logo.png'
import {Link} from 'react-router-dom'

function Navbar() {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 565);

    useEffect(() => {
        const handleResize = () => {
        setIsMobile(window.innerWidth < 565);
        };

        window.addEventListener('resize', handleResize);

        // Cleanup listener on component unmount
        return () => {
        window.removeEventListener('resize', handleResize);
        };
    }, []);
  return (
    <>
    <div className='nav-bg position-fixed w-100 px-5'>
    <nav className="navbar px-5 navbar-expand-lg navbar-light">
    {isMobile && (
        <div className='w-100 d-flex justify-content-center align-items-center'>
            <Link className="navbar-brand" to='/'>
                <img className='w-100' src={logo} alt="logo" />
            </Link>
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
            </button>
        </div>
    )}
    {!isMobile && (
        <>
            <Link className="navbar-brand" to='/'>
                <img className='w-75' src={logo} alt="logo" />
            </Link>
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
            </button>
        </>
    )}
    <div className="collapse navbar-collapse" id="navbarSupportedContent">
        <ul className="navbar-nav justify-content-center align-items-center ms-auto">
            <li className="nav-item pe-4">
                <Link className="custom-nav-link text-light" to='/'>Home</Link>
            </li>
            <li className="nav-item pe-4">
                <Link className="custom-nav-link text-light" to='/about'>About</Link>
            </li>
            <li className="nav-item pe-4">
                <Link className="custom-nav-link text-light" to='/applications'>Applications</Link>
            </li>
            <li className="nav-item pe-4">
                <Link to='/contact'>
                    <button className='btn-nav-style rounded-5'>Contact Us <i className="ps-2 fa-solid fa-envelope"></i></button>
                </Link>
            </li>
        </ul>
    </div>
</nav>

    </div>
    </>
  );
}

export default Navbar;